var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useConfig } from '../../context/ConfigContext';
import { useWritableCalendars } from '../../hooks/useWritableCalendars';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useEventDetailContext } from '../context/EventDetailContextProvider';
import { EventDetailsSuccessActions } from '../types';
import { canShowRsvpActions, getCurrentUserInvitee, normalizeRsvpStatus, } from '../utils/eventRsvp';
export var useEventRsvp = function () {
    var _a = useEventDetailContext(), event = _a.event, onError = _a.onError, onSuccess = _a.onSuccess, updateInviteeResponseStatus = _a.updateInviteeResponseStatus;
    var _b = useConfig(), accessToken = _b.accessToken, environmentUrls = _b.environmentUrls, tenantId = _b.tenantId, userContext = _b.userContext;
    var currentUser = userContext.currentUser;
    var getWritableCalendars = useWritableCalendars().getWritableCalendars;
    var rsvpForInvitee = useEventApi({
        onError: onError,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        tenantId: tenantId,
        currentOrg: userContext.currentOrg,
        accessToken: accessToken,
    }).rsvpForInvitee;
    var _c = __read(useState(true), 2), calendarsLoading = _c[0], setCalendarsLoading = _c[1];
    var _d = __read(useState([]), 2), writableCalendars = _d[0], setWritableCalendars = _d[1];
    var _e = __read(useState(null), 2), submittingStatus = _e[0], setSubmittingStatus = _e[1];
    var abortControllerRef = useRef(null);
    useEffect(function () {
        abortControllerRef.current = new AbortController();
        var signal = abortControllerRef.current.signal;
        var loadCalendars = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setCalendarsLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getWritableCalendars()];
                    case 2:
                        response = _b.sent();
                        if (signal.aborted)
                            return [2 /*return*/];
                        setWritableCalendars((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        if (!signal.aborted) {
                            setWritableCalendars([]);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!signal.aborted) {
                            setCalendarsLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void loadCalendars();
        return function () {
            var _a;
            (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, [getWritableCalendars]);
    var currentUserInvitee = useMemo(function () {
        if (!event)
            return undefined;
        return getCurrentUserInvitee(event, currentUser);
    }, [event, currentUser]);
    var canShow = useMemo(function () {
        if (!event || calendarsLoading)
            return false;
        return canShowRsvpActions(event, currentUser, writableCalendars);
    }, [event, currentUser, writableCalendars, calendarsLoading]);
    var currentStatus = useMemo(function () { return normalizeRsvpStatus(currentUserInvitee === null || currentUserInvitee === void 0 ? void 0 : currentUserInvitee.response_status); }, [currentUserInvitee === null || currentUserInvitee === void 0 ? void 0 : currentUserInvitee.response_status]);
    var submitRsvp = useCallback(function (status, comment) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event === null || event === void 0 ? void 0 : event.id) || !(currentUserInvitee === null || currentUserInvitee === void 0 ? void 0 : currentUserInvitee.email))
                        return [2 /*return*/, false];
                    setSubmittingStatus(status);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, rsvpForInvitee(event.id, currentUserInvitee.email, status, comment)];
                case 2:
                    success = _a.sent();
                    if (success) {
                        updateInviteeResponseStatus(currentUserInvitee.email, status);
                        onSuccess(EventDetailsSuccessActions.RSVP_EVENT);
                    }
                    return [2 /*return*/, success];
                case 3:
                    setSubmittingStatus(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        event === null || event === void 0 ? void 0 : event.id,
        currentUserInvitee === null || currentUserInvitee === void 0 ? void 0 : currentUserInvitee.email,
        rsvpForInvitee,
        updateInviteeResponseStatus,
        onSuccess,
    ]);
    return {
        canShow: canShow,
        calendarsLoading: calendarsLoading,
        currentStatus: currentStatus,
        currentUserInvitee: currentUserInvitee,
        submittingStatus: submittingStatus,
        submitRsvp: submitRsvp,
    };
};
